/* .container {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
} */

.container {
    display: inline-block;
    position: relative;
}

/* 🔴 Small circular badge */
.badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background-color: #d83b01; /* Fluent orange/red */
    color: white;
    border-radius: 50%;
    font-size: 10px;
    font-weight: bold;
    padding: 2px 5px;
    min-width: 16px;
    height: 16px;
    line-height: 12px;
    text-align: center;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}
